export default __webpack_public_path__ + "d60f6cd7c7bf9dd81a0a53ea9ceda406.mp3";